import type { Appointment } from './appointment.types';
export function hasStaffConflict(appointments: Appointment[], candidate: { storeId: string; employeeId: string; start: number; duration: number }) {
  const end = candidate.start + candidate.duration * 60000;
  return appointments.some(a => a.store_id === candidate.storeId && a.employee_id === candidate.employeeId && a.status_raw < 3
    && candidate.start < a.appointment_time_ms + Math.max(a.duration_minutes, 30) * 60000 && end > a.appointment_time_ms);
}
